import SvgIcoSquare from './SvgIcoSquare';

export default SvgIcoSquare;
